export var isTestingJest = process.env.NODE_ENV === 'test' || typeof rstest !== 'undefined' || process.env.RSTEST === 'true';